import { TTintSettings } from '../types/tint-settings.type';
import { TTintColor } from '../types/tint-color.type';
import { STAGE } from '../consts/tint-service.consts';
import { handleChangePriceInRobotintModal } from './handle-сhange-price-in-robotint-modal.helper';

type TProps = {
  clientId: string;
  secret: string;
  colorSelect: (color: Required<TTintColor>) => void;
  robotintLink: string;
};

export const getRobotintOptions = ({ clientId, secret, colorSelect, robotintLink }: TProps) => {
  const tintSettings: TTintSettings = {
    CLIENT_ID: clientId,
    SECRET: secret,
    WITH_PRICE: 1,
    USE_SWITCHER: 0,
  };

  if (robotintLink.includes(STAGE)) {
    tintSettings.DOMAIN = robotintLink;
  }

  return {
    tintSettings,
    siteSettings: {
      colorSelect,
      processPrice: handleChangePriceInRobotintModal,
      bgZindex: 10000,
      basketURL: '/basket/',
    },
  };
};
